export const result = {
    labels: {
    },
    modal: {
        titles: {
        },
        messages: {
        },
    },
    texts: {
        result_empty: "You have no RESULTS to display!",
    },
};
